<template>
  <!-- 保单列表组件 -->
  <div class="insurancelist">
    <!-- 保单列表  搜索有数据 -->
    <div class="hasData" v-if="isShow">
      <el-table
        empty-text=" "
        v-loading="loading"
        :data="list"
        stripe
        :row-class-name="TableRow"
        :header-cell-style="thClass"
        :cell-style="{ color: '#666666' }"
      >
        <el-table-column
          label="作物"
          width="224px
        "
        >
          <template slot-scope="scope">
            <span class="zuoweNameImg"
              ><img :src="scope.row.cropGroupImgUrl" alt=""
            /></span>
            <span>{{ scope.row.cropGroupName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="投保面积" width="234px">
          <template slot-scope="scope">
            <div class="totalLands">
              <span>
                {{ scope.row.coFarmInsureOrderLandVOList.length }}个地块</span
              >
              <span class="textColor">
                &nbsp;&nbsp;({{
                  setAcre(scope.row.coFarmInsureOrderLandVOList)
                }}亩)</span
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column label="起保时间" width="133px">
          <template slot-scope="scope">
            {{ scope.row.insureEffectiveStartDate | formatDate("yyyy-MM-dd") }}
          </template>
        </el-table-column>
        <el-table-column label="终保时间" width="133px">
          <template slot-scope="scope">
            {{ scope.row.insureEffectiveEndDate | formatDate("yyyy-MM-dd") }}
          </template>
        </el-table-column>
        <el-table-column label="自缴保费" width="112px">
          <template slot-scope="scope">
            {{
              scope.row.selfPremiumTotal
                ? scope.row.selfPremiumTotal + "元 "
                : "-"
            }}
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100px">
          <!--  状态 10 已出单 20 保障中  30 判赔中 40 未发生理赔  41 判赔成功  50 理赔成功 -->
          <template slot-scope="scope">
            <span
              class="statusColor"
              :class="policyColor[scope.row.insurePolicyStatus]"
              >{{ setpolicy[scope.row.insurePolicyStatus] }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="184px ">
          <template slot-scope="scope">
            <el-button
              @click="checkContent(scope.row)"
              type="text"
              size="small"
              class="button14"
              >查看</el-button
            >
            <el-button
              @click="downloadEle(scope.row)"
              type="text"
              size="small"
              class="button14"
              >下载电子保单
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 搜索后无数据 -->
    <div class="noDataImg" v-else>
      <div class="imgNo">
        <img src="~@/assets/images/insuranceImg/nodataImg.png" alt="" />
      </div>
      <p style="color: #333">未找到符合条件的数据</p>
    </div>
  </div>
</template>

<script>
import { setStorage } from "@/utils/storage";
import sameIn from "@/mixins/listsdetails.js";
import { policy_state } from "@/confing/map_tab.js";
export default {
  name: "TableList",
  mixins: [sameIn],
  data() {
    return {
      maxHeignt: 500,
      setpolicy: policy_state,
      policyColor: {
        10: "colorHui",
        40: "colorHui",
      },
    };
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
    isShow: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  created() {},

  computed: {},

  methods: {
    setAcre(list) {
      let countNum = 0;
      list.forEach((ele) => {
        countNum = countNum + ele.statisticsLandAcre;
      });
      let res = countNum.toString().indexOf(".");
      if (res !== -1) {
        if (countNum.toString().substr(res + 1).length > 2) {
          countNum = countNum.toFixed(2);
        }
      }
      return countNum;
    },

    checkContent(row) {
      setStorage("baodanDetails", row);
      this.$router.push({
        name: "DetailsIndex",
        query: {
          type: 1,
          id: row.id,
        },
      });
    },
    // 下载电子保单
    downloadEle(row) {
      window.open(row.elecPolicyUrl);
    },
  },
};
</script>

<style lang="scss" scoped>
.hasData {
  height: 100%;
}
.totalLands {
  line-height: 70px;
  display: flex;
  flex-direction: row;
  .textColor {
    color: #ccc;
  }
}
.statusColor {
  color: $--color-primary;
}
.colorHui {
  color: #666666;
}
</style>
